
export const WALLET_TYPE = {
  DEMO: 'demo',
  REAL: 'real',
  DEMO_FUTURES: 'demo_futures',
  REAL_FUTURES: 'real_futures',
}